import dayjs, { Dayjs } from 'dayjs';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { Flex } from '@atoms/layout';
import { ArchivedShiftIcon, FaIcon, HotShiftIcon, RotationIcon, SeriesIcon, SharedShiftIcon } from '@atoms/icons';

type ShiftTypeProps = {
  startDate: Dayjs;
  endDate: Dayjs;
  disableShiftType?: boolean;
  timeDisplay?: 'full' | 'short';
  isArchive?: boolean;
  isUrgent?: boolean;
  isShared?: boolean;
  isSeries?: boolean;
  isRotation?: boolean;
  isSingle?: boolean;
  isMultiple?: boolean;
};

// TODO: probably the name is not very good. We add a lot of different data here.
// Probably we should rename it to `ShiftPeriod` or something like that
export function RecurrenceDates({
  startDate,
  endDate,
  isArchive,
  isRotation,
  isSeries,
  isShared,
  isUrgent,
  isSingle,
  isMultiple,
}: ShiftTypeProps) {
  const theme = useTheme();
  const formattedStart = dayjs(startDate).tz('UTC').format('MM.DD');
  const formattedEnd = dayjs(endDate).tz('UTC').format('MM.DD.YYYY');

  const length = endDate.diff(startDate, 'milliseconds');

  return (
    <Stack direction={'column'} sx={{ height: '100%' }}>
      <Box flex={1} />
      <Flex column maxWidth="100%">
        <Typography variant="body2" noWrap>
          {`${formattedStart} - ${formattedEnd}`}
        </Typography>

        <Flex gap={1} alignCenter>
          <Typography variant="caption" color="text.secondary" lineHeight={1.5}>
            {dayjs.duration(length, 'milliseconds').humanize()}
          </Typography>
          {isRotation && (
            <Tooltip title="Rotation" placement="top">
              <Flex color={(theme) => theme.palette.shiftRecurrence.rotation.main}>
                <RotationIcon />
              </Flex>
            </Tooltip>
          )}
          {isSeries && (
            <Tooltip title="Series" placement="top">
              <Flex color={(theme) => theme.palette.shiftRecurrence.series.main}>
                <SeriesIcon />
              </Flex>
            </Tooltip>
          )}
          {isUrgent && (
            <Tooltip title="Urgent" placement="top">
              <Flex color={(theme) => theme.palette.shiftRecurrence.series.main}>
                <HotShiftIcon />
              </Flex>
            </Tooltip>
          )}
          {isShared && (
            <Tooltip title="Shared" placement="top">
              <Flex color={(theme) => theme.palette.shiftRecurrence.series.main}>
                <SharedShiftIcon />
              </Flex>
            </Tooltip>
          )}
          {isArchive && (
            <Tooltip title="Archived" placement="top">
              <Flex color={(theme) => theme.palette.shiftRecurrence.series.main} width={13} height={15}>
                <ArchivedShiftIcon />
              </Flex>
            </Tooltip>
          )}
          {isSingle && (
            <Tooltip title="Single Assignee" placement="top">
              <Flex color={(theme) => theme.palette.shiftRecurrence.series.main} width={13} height={15}>
                <FaIcon
                  variant="duotone"
                  name="user"
                  height={'10px'}
                  width={'10px'}
                  color={theme.palette.primary.main}
                />
              </Flex>
            </Tooltip>
          )}
          {isMultiple && (
            <Tooltip title="Multiple Assignees" placement="top">
              <Flex color={(theme) => theme.palette.shiftRecurrence.series.main} width={13} height={15}>
                <FaIcon
                  variant="duotone"
                  name="users"
                  height={'15px'}
                  width={'15px'}
                  color={theme.palette.primary.main}
                />
              </Flex>
            </Tooltip>
          )}
        </Flex>
      </Flex>
      <Box flex={1} />
    </Stack>
  );
}
